import React from "react";
import PropTypes from 'prop-types';

export const getPagesCount = (totalSize, sizePerPage) => {
  return Math.ceil(totalSize / sizePerPage);
};

export const getPages = (page, pagesCount, paginationSize) => {
  const result = [];
  if (!page || pagesCount < page) {
    return result;
  }

  switch (true) {
    case pagesCount === 1:
      result.push(1);
      return result;

    case pagesCount < paginationSize + 1:
      for (let i = 1; i <= pagesCount; i++) {
        result.push(i);
      }
      return result;

    case page === 1:
      for (let i = 1; i < paginationSize + 1; i++) {
        if (i < pagesCount) {
          result.push(i);
        }
      }
      return result;

    case page === pagesCount:
      for (let i = pagesCount - paginationSize + 1; i <= pagesCount; i++) {
        if (i <= pagesCount) {
          result.push(i);
        }
      }
      return result;

    default:
      break;
  }

  const shiftCount = Math.floor(paginationSize / 2);

  switch (true) {
    case shiftCount < 1:
      result.push(page);
      return result;

    case page < shiftCount + 2:
      for (let i = 1; i < paginationSize + 1; i++) {
        result.push(i);
      }
      return result;

    case pagesCount - page < shiftCount + 2:
      for (let i = pagesCount - paginationSize; i <= pagesCount; i++) {
        result.push(i);
      }
      return result;

    default:
      break;
  }

  for (let i = page - shiftCount; i < page; i++) {
    if (i > 0) {
      result.push(i);
    }
  }

  result.push(page);
  for (let i = page + 1; i < page + shiftCount + 1 && i <= pagesCount; i++) {
    result.push(i);
  }

  return result;
};

export function getHandlerTableChange(setQueryParams) {
  return (type, { page, sizePerPage, sortField, sortOrder, _data }) => {
    const pageNumber = page || 1;
    setQueryParams((prev) => {
      switch (type) {
        case "sort":
          return { ...prev, sortOrder, sortField };
        case "pagination":
          return { ...prev, pageNumber, pageSize: sizePerPage };
        default:
          return prev;
      }
    });
  };
}

export function PleaseWaitMessage({ entities }) {
  return <>{entities === null && <div>Please wait...</div>}</>;
}

PleaseWaitMessage.propTypes = {
  entities: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
};

export function NoRecordsFoundMessage({ entities }) {
  const customersList = entities === null ? [] : entities;
  return (
    <>
      {customersList.length === 0 && entities !== null && (
        <div>No records found</div>
      )}
    </>
  );
}

NoRecordsFoundMessage.propTypes = {
  entities: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
};
